// ------------------------------------------------------------------------
// Basic colour values defined.
// ------------------------------------------------------------------------

const AZURE = '#30bbdd';
const COBALT = '#194378';
const MELON = '#e86e6e';
const SOFT_BLUE = '#6a8be5';
const PEA_TWO = '#add429';
const GOLD = '#e5b515';
const GREY_BLUE = '#68c6c6';
const BLACK_TWO = '#262626';
const WHITE_TWO = '#ffffff';
const ORANGE = '#f7b028';
const GRAY = '#d2dde6';

// ------------------------------------------------------------------------
// Basic colours exposed to use across app and in components.
// ------------------------------------------------------------------------
export const APP_PRIMARY = AZURE;
export const APP_SECONDARY = COBALT;
export const APP_SECTION_GENERAL = MELON;
export const APP_SECTION_LIFESTYLE = SOFT_BLUE;
export const APP_SECTION_SYMPTOMS = APP_PRIMARY; //default
export const APP_SECTION_DISEASE_HISTORY = APP_PRIMARY; //default
export const APP_SECTION_MEDICATIONS = APP_PRIMARY; //default
export const APP_SECTION_ENVIRONMENT = APP_PRIMARY; //default
export const APP_SECTION_ACTIVITY = PEA_TWO;
export const APP_SECTION_STRESS = SOFT_BLUE;
export const APP_SECTION_NUTRITION = GOLD;
export const APP_SECTION_WEARABLE = GREY_BLUE;

export const APP_TEXT_PRIMARY = BLACK_TWO;
export const APP_TEXT_SECONDARY = WHITE_TWO;

// ------------------------------------------------------------------------
// Other necessary colours xposed to use across app and in components.
// ------------------------------------------------------------------------

// Section title gradient colours
export const BRIGHT_LIGHT_BLUE = '#30eaff';
export const BLUISH = '#2494ba';

// Checkbox colour
export const COOL_BLUE = '#33b0ce';

// Navigation
export const TRANSPARENT_WHITE = 'rgba(255, 255, 255, 0.91)';
export const NEVADA_GRAY = '#636a72';

// Dense Chart colors
export const LOW_BAR_COLOR = '#C6D3DC';
export const AWG_BAR_COLOR = '#94A8BA';
export const HIGH_BAR_COLOR = '#596F86';
export const SELECTED_BAR_COLOR = '#2FB9DA';
export const EMPTY_BAR_COLOR = GRAY;

export const LOW_RISK_BAR_COLOR = PEA_TWO;
export const AVG_RISK_BAR_COLOR = ORANGE;
export const HIGH_RISK_BAR_COLOR = MELON;

// SkinCare color
export const SKINCARE_COLOR = '#a64daa';

export const LOW_RISK_COLOR = '#52c463';
export const MODERATE_RISK_COLOR = '#edab31';
export const HIGH_RISK_COLOR = '#f26914';
export const SEVERE_RISK_COLOR = '#d90000';
export const CRITICAL_RISK_COLOR = '#c10a49';
export const UNKNOWN_RISK_COLOR = '#33afce';
